// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header_B0ZHzcAk6V8NyKSuaL0r3","heading":"styles_heading_3PzHg6Pro0E9vD-j7Q-8nJ"};